var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8,9.8h0c-15,1-28,6.2-38.7,15.4a2.8,2.8,0,0,1-1.6.7c-7.4.6-15.9,4.7-21.6,10.4A32.2,32.2,0,0,0,14,44.2a3,3,0,0,0,4,4.1,24.9,24.9,0,0,1,8.3-2.5c-1.5,2.9-3.1,6.2-3.9,8V54a3,3,0,0,0,.6,3.4l.9.9L10.2,85.9a3,3,0,0,0,4,4L41.7,76.2l.8.8a3,3,0,0,0,3.4.6l8.3-4.1A25.8,25.8,0,0,1,51.7,82a3,3,0,0,0,4,4,29.1,29.1,0,0,0,8-5.8c5.8-5.8,9.9-14.4,10.4-21.9a2.7,2.7,0,0,1,.7-1.6C84,46.1,89.1,33.1,90.1,18.2a7.9,7.9,0,0,0-8.4-8.4ZM19.5,80.5l8.8-17.7,8.9,8.9Zm45.3-31h0a10.1,10.1,0,1,1,3-7.1A10,10,0,0,1,64.8,49.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket_launch.5fb6963c85d1dd0e1f990e8f6f914261.svg";
export { ForwardRef as ReactComponent };